import { ITransactionService } from './ITransactionService';
import { of as observableOf, Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { HttpRequestService } from '../../http-request.service';
import { apiURLs, PREVILEGEKEY } from '../../../globalcontants';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DocumentApprovalEntity, TransactionHeaderEntity } from '../../../models/Transactions/DocumentApprovalEntity';
import { SearchHistoryEntity, SearchHistoryPostEntity } from '../../../models/Transactions/SearchHistoryEntity';
import { ValidationEntity } from '../../../models/Utilities/ValidationEntity';
import { Dictionary } from 'src/app/shared/services/Dictionary.Service';
import { RequisitionEntity } from '../../../models/Transactions/RequisitionEntity';

@Injectable({
  providedIn: 'root'
})
export class TransactionService implements ITransactionService {
  constructor(private httpService: HttpRequestService, private http: HttpClient) { }

  /* Get Transaction Status Summary */
  GetTransactionStatusSummary(siteId: number = 0, groupBySourceId: number): Observable<DocumentApprovalEntity[]> {
    const inputParams = new HttpParams().set('siteId', siteId.toString()).set('groupBySourceId', groupBySourceId.toString());
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.TransactionAPI.GetTransactionStatusSummary);
  }

  /* Get Transaction Status Summary */
  GetTransactionHeaderSummary(typeId: number = 1): Observable<TransactionHeaderEntity> {
    const requestUrl = apiURLs.InvertoryManagement.GetTransactionHeader + typeId;
    return this.httpService.GetHttpRequest(requestUrl);
  }

  /* Get Search Sources */
  GetSearchSource(): Observable<SearchHistoryEntity[]> {
    return this.httpService.GetHttpRequest(apiURLs.TransactionAPI.GetSearchSource).pipe(share());
  }
  /**
   * @version 13.1 UI Modernization
   * @method GetItemSearchSource
   * @returns 
   */
  /* Get Search Sources */
  GetItemSearchSource(): Observable<SearchHistoryEntity[]> {
    return this.http.get<SearchHistoryEntity[]>(apiURLs.Assets.GetItemSource);
  }

  /* Get Search History */
  GetSearchHistory(userId: number, sourceId: number): Observable<SearchHistoryEntity[]> {
    const inputParams = new HttpParams().set('userId', userId.toString()).set('sourceId', sourceId.toString());
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.TransactionAPI.GetSearchHistory);
  }

  /* Save Search History */
  SaveSearchHistory(entity: SearchHistoryEntity): Observable<ValidationEntity> {
    return this.httpService.postHttpRequest(apiURLs.TransactionAPI.SaveSearchHistory, entity);

  }

  /**
   * @version 13.2
   * @param 
   * @returns 
   */
  GetIngredientSearchHistory(params: any): Observable<any> {
    const requisitionRequestUrl = apiURLs.TransactionManagement.GetSearchHistory + params
    return this.httpService.postHttpRequest(apiURLs.TransactionManagement.GetSearchHistory, params);
  }

  SaveIngredientSearchHistory(entity: SearchHistoryPostEntity): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.TransactionManagement.SaveSearchHistory, entity);
  }

  /* Cancels or Batch cancels Transactions(Requisition,Spoilage,PurchaseRequest(RQA)) for the given ids. */
  CancelTransactions(entity: RequisitionEntity): Observable<ValidationEntity> {
    return this.httpService.postHttpRequest(apiURLs.TransactionAPI.CancelTransactions, entity);
  }
  /**
   * @version UI 13.2
   * @param entity 
   * @returns 
   */
  /* Cancels or Batch cancels Transactions(Requisition,Spoilage,PurchaseRequest(RQA)) for the given ids. */
  CancelReqHead(entity: any): Observable<any> {
    const reqHeadCancel = `${apiURLs.TransactionManagement.GetRequisitionHead}/` + entity;
    return this.httpService.deleteHttpRequest(reqHeadCancel);
  }

  /* Locks / Unlocks the transactions.. */
  LockUnlockTransactions(entity: RequisitionEntity): Observable<ValidationEntity> {
    return this.httpService.postHttpRequest(apiURLs.TransactionAPI.LockUnlockTransaction, entity);
  }

  GetPriority(): Observable<any[]> {
    return this.httpService.GetHttpRequest(apiURLs.InvertoryManagement.GetPriority);
  }

  ReverseTransaction(reversalType: number, selectedTransIds: number[], enteredBy: string, remark: string = '')
    : Observable<ValidationEntity> {
    const entity = {
      'TransTypeId': reversalType,
      'CreatedBy': enteredBy,
      'RequisitionHeaderDetail': {
        'InventoryHeadDetail': {
          'SelectedTransNumbers': selectedTransIds,
          'Remarks': ''
        }
      },
      'APIKEY': PREVILEGEKEY.PostReverseTransactions
    };
    return this.httpService.postHttpRequest(apiURLs.TransactionAPI.ReverseTransaction, entity);
  }

  /**
 * @version UI 13.2
 * @param entity 
 * @returns 
 */
  ReverseTrans(entity: any): Observable<any> {
    const reqHeadCancel = `${apiURLs.TransactionManagement.GetTransferHead}/` + entity;
    return this.httpService.deleteHttpRequest(reqHeadCancel);
  }

  ReverseSpoilage(entity: any): Observable<any> {
    const spoilageHeadCancel = `${apiURLs.TransactionManagement.GetTransGetSpoilageSummary}/` + entity;
    return this.httpService.deleteHttpRequest(spoilageHeadCancel);
  }
}
